import React from "react";
import './index.scss';
import messenger from "../../images/messengers/messenger.svg";
import telegram from "../../images/messengers/telegram.svg";
import viber from "../../images/messengers/viber.svg";
import {ReactSVG} from "react-svg";
import {strings} from "../../strings/strings";


export const Feedback = () =>
    <div className='feedback'>
        <div className="feedback__header">{strings.feedback.title}</div>
        <div className="feedback__message">{strings.feedback.message}</div>
        <div className="feedback__buttons">
            <a href="https://t.me/info_line_bot" target="_blank"><ReactSVG src={telegram}/></a>
            <a href="viber://pa?chatURI=infoline" target="_blank"><ReactSVG src={viber}/></a>
            <a href="https://www.facebook.com/arxukraine" target="_blank"><ReactSVG src={messenger}/></a>
        </div>
    </div>